export default __webpack_public_path__ + "static/media/mars12.07d15bad.gif";